import jwt from 'jsonwebtoken';

export default function checkTokenValidity(token){
    //carrega o token, extrai a data de validade dele, e verifica se já foi ultrapassada
    const now = new Date();
    var decoded = jwt.decode(token, {complete: true});
    var valid = new Date(decoded.payload.exp*1000) > now

    return valid
}